<div *transloco="let t">
  <div>
    <div class="form-group row mb-4 ml-1 items-center">
      <ISwitchButton
        [options]="[SelectionModes.Bulk, SelectionModes.FromProductSegment]"
        [buttonTexts]="[t('add-product-tracking-modal.asin_list'), t('add-product-tracking-modal.product_segments')]"
        [buttonTooltips]="['', '']"
        [selected]="selectionMode"
        (buttonClicked)="changeProductSelectionMode($event)"
      ></ISwitchButton>
    </div>
    <div class="flex flex-row">
      <div class="row mx-1 w-1/2">
        @if (selectionMode === SelectionModes.Bulk) {
          <div class="h-full w-full">
            <textarea
              [(ngModel)]="bulkAsins"
              class="h-[35rem]"
              placeholder="{{ t('add-product-tracking-modal.asins_to_track') }}"
              aria-label="ASIN list text area"
            ></textarea>
            @if (errors && errors.length > 0) {
              <div class="list-errors mt-2 w-40">
                <ul class="list-group">
                  <li class="list-group-item list-group-item list-group-item-warning flex justify-between">
                    <span>{{ t("catalog-upload.asins_ignored") }}</span>

                    <button
                      iButton
                      variant="secondary"
                      size="icon-sm"
                      [iTooltip]="t('catalog-upload.close_error_table')"
                      (click)="errors = []"
                    >
                      <IIcon name="close" />
                    </button>
                  </li>
                  @for (error of errors; track error) {
                    <li class="list-group-item list-group-item-secondary py-0">
                      {{ error }}
                    </li>
                  }
                </ul>
              </div>
            }
            <div class="m-1 flex w-full justify-end">
              <button iButton class="ml-2" (click)="addProduct()" [disabled]="asinToAddInvalid()">
                {{ t("common.add") }}
              </button>
            </div>
          </div>
        }
        @if (selectionMode === SelectionModes.FromProductSegment) {
          <div class="h-full w-full rounded-sm border">
            <div>
              <div class="border-b p-1">
                <span
                  class="select-button-box inline-block pl-3"
                  [iTooltip]="
                    selectedProductSegments().length === productSegments()?.length
                      ? t('add-product-tracking-modal.unselect_all_product_segments')
                      : t('add-product-tracking-modal.select_all_productsegments')
                  "
                >
                  @if (selectedProductSegments().length !== productSegments()?.length) {
                    <IIcon name="square" class="text-lg" (click)="selectAllProductSegments()" />
                  }
                  @if (selectedProductSegments().length === productSegments()?.length) {
                    <IIcon name="squareCheck" class="text-lg" (click)="unselectAllProductSegments()" />
                  }
                </span>
                <div iInputGroup>
                  <IIcon name="search" />
                  <input
                    iInputGroupInput
                    [placeholder]="t('add-product-tracking-modal.search_product_segments')"
                    [ngModel]="''"
                    (ngModelChange)="setProductSegmentFilter($event)"
                  />
                </div>
              </div>
              <div class="product-segments mt-2 mb-3 pr-1 pl-1">
                @for (productSegment of filteredProductSegments(); track productSegment) {
                  <div class="cmb-2 w-full">
                    <div
                      class="flex pt-2 pb-2 pl-3"
                      [class.disabledProductSegments]="
                        getProductSegmentItems(productSegment).length === 0 ||
                        productSegmentAlreadySelected(productSegment)
                      "
                    >
                      @if (!productSegmentAlreadySelected(productSegment)) {
                        <span
                          class="select-button-box"
                          [iTooltip]="t('add-product-tracking-modal.select_segment_name', [productSegment.name])"
                          (click)="selectProductSegment(productSegment)"
                        >
                          <IIcon
                            class="text-lg"
                            [name]="isProductSegmentSelected(productSegment) ? 'squareCheck' : 'square'"
                          />
                        </span>
                      }
                      @if (getProductSegmentItems(productSegment).length === 0) {
                        <span
                          class="select-button-box"
                          [iTooltip]="t('add-product-tracking-modal.no_asin_segment', [productSegment.name])"
                        >
                          <IIcon name="square" class="text-lg" />
                        </span>
                      }
                      @if (
                        getProductSegmentItems(productSegment).length > 0 &&
                        productSegmentAlreadySelected(productSegment)
                      ) {
                        <span
                          class="select-button-box"
                          [iTooltip]="t('add-product-tracking-modal.already_tracked', [productSegment.name])"
                        >
                          <IIcon name="square" class="text-lg" />
                        </span>
                      }
                      <p
                        class="product-segment-content inline-block w-85 pl-3"
                        [iTooltip]="
                          t('add-product-tracking-modal.product_segment_length', {
                            name: productSegment.name,
                            count: getProductSegmentItems(productSegment).length,
                          })
                        "
                      >
                        {{ productSegment.name }}
                      </p>
                    </div>
                  </div>
                }
              </div>
              <div class="float-right">
                <span [iTooltip]="t('add-product-tracking-modal.add_products_from_the_selected_product_segments')">
                  <button
                    iButton
                    class="mx-1"
                    (click)="addProductsByProductSegment()"
                    [disabled]="isProductSegmentAddButtonDisabled()"
                  >
                    {{ t("common.add") }}
                  </button>
                </span>
                <ng-content select="[productSegment]"></ng-content>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="selection-arrow mx-2">
        <div class="flex h-full w-full items-center justify-center">
          <IIcon
            name="arrowRight"
            class="arrow pointer text-lg"
            (click)="selectionMode === SelectionModes.FromProductSegment ? addProductsByProductSegment() : addProduct()"
          />
        </div>
      </div>
      <div class="product-div w-1/2 overflow-auto shadow-xs">
        <div class="flex flex-row items-center justify-between p-3">
          <div iInputGroup class="mb-1 font-medium">
            <IIcon name="search" />
            <input
              iInputGroupInput
              [placeholder]="t('common.search')"
              [ngModel]="''"
              (ngModelChange)="setProductFilter($event)"
            />
          </div>
          <div class="mr-3">
            <span
              (click)="deleteAllAsins()"
              [iTooltip]="t('common.clear_all')"
              iTooltipPlacement="left"
              class="cursor-pointer"
            >
              <IIcon name="trash" />
            </span>
          </div>
        </div>
        @for (asin of filteredAsinList; track asin) {
          <div class="flex flex-row justify-between px-3">
            <app-product-view [asin]="asin" [marketplace]="data.marketplace" class="w-90"></app-product-view>
            <div class="mr-3">
              <span
                (click)="deleteAsin(asin)"
                [iTooltip]="t('add-product-tracking-modal.do_not_track_this_product')"
                iTooltipPlacement="left"
                class="cursor-pointer"
              >
                <IIcon name="trash" />
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="flex justify-end gap-2" *transloco="let t">
  <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>

  <button iButton type="submit" size="md" [disabled]="!canSave()" (click)="onSave()">
    {{ t("common.save") }}
  </button>
</div>
